import {
  SdgAlignmentsLayout,
  SdgAlignmentValence,
  SdgId,
} from '@upright/common/model/output/scores/sdg-alignment/types';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { BouSpacingLevel, fluidHorizontalPadding } from '@upright/ui/common/generic/layout/bou-spacing';
import styled from 'styled-components';
import { useSdgAlignmentsContext } from '../context';
import { getSdgRowHeight } from '../shared';
import { SdgAlignmentBars } from './sdg-alignment-bars';
import { SdgIconAndName } from './sdg-icon-and-name';

export interface SdgRowProps {
  sdgId: SdgId;
  onClick: (valence: SdgAlignmentValence, sdg: SdgId) => void;
}

export const SdgRow = (props: SdgRowProps) => {
  const layout = useSdgAlignmentsContext().viewOptions.layout;

  return (
    <Root layout={layout}>
      <SdgIconAndName {...props} />
      <SdgAlignmentBars {...props} />
    </Root>
  );
};

const Root = styled.div<{ layout?: SdgAlignmentsLayout }>`
  ${fluidHorizontalPadding(BouSpacingLevel.SMALL)}
  height: ${props => getSdgRowHeight(props.layout)};
  display: flex;
  align-items: center;
  & + & {
    border-top: 1px solid ${BouColor.TOOL_BORDER_LIGHTER_GRAY};
  }
`;
